<ul>
  @for(link of links; track link){
    <li>
      <a routerLink="/{{link.value}}" class="text-content">{{ link.name | titlecase }}</a>
    </li>
  }
</ul>
